import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class QueryFiltersService {

  QUERY_EMPTY = '{"and":[]}';
  QUERY_EMPTY_JSON = JSON.parse(this.QUERY_EMPTY);

  isQueryNotEmpty(query: string): boolean {
    return query && query !== this.QUERY_EMPTY && query !== "{}";
  }
}
